/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { EmbersMenu } from '../../../../menu/menu';
import { EmbersMenuItem } from '../../../../menuItem';
export function ColumnMenu(_ref) {
  var anchorEl = _ref.anchorEl,
    open = _ref.open,
    onClose = _ref.onClose,
    items = _ref.items,
    selectedItems = _ref.selectedItems,
    onColumnChange = _ref.onColumnChange;
  var intl = useIntl();
  var handleMenuItemClick = function handleMenuItemClick(e) {
    var clickedItem = e.currentTarget;
    var selectedIds = selectedItems.map(function (selectedItem) {
      return selectedItem.id;
    });
    var clickedItemNdx = selectedIds.indexOf(clickedItem.id);
    if (clickedItemNdx === -1) {
      selectedIds.push(clickedItem.id);
    } else {
      selectedIds.splice(clickedItemNdx, 1);
    }
    onColumnChange(selectedIds);
  };
  var renderMenuItems = function renderMenuItems() {
    var checkItems = items.map(function (item, ndx) {
      return /*#__PURE__*/React.createElement(EmbersMenuItem, {
        key: 'columnMenuItem_' + ndx,
        id: item.id,
        checkable: true,
        disabled: selectedItems.length === 1 && item.id === selectedItems[0].id,
        selected: !!selectedItems.find(function (selectedItem) {
          return selectedItem.id === item.id;
        }),
        onClick: handleMenuItemClick,
        onCloseRequest: onClose
      }, item.label);
    });
    return checkItems;
  };
  var menuItems = renderMenuItems();
  return /*#__PURE__*/React.createElement(EmbersMenu, {
    title: intl.formatMessage({
      id: 'embers.table.showColumn',
      defaultMessage: 'Show columns'
    }),
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    placement: "bottom-end",
    verticalOffset: -4,
    className: "EmbersColumnMenu-root",
    menuScrollProps: {
      removeScroll: true
    },
    ariaProps: {
      'aria-multiselectable': 'true'
    }
  }, menuItems);
}